import axios from "axios";
import {
    URLAPI,
    ESTABLISHMENT_PATH,
    ESTABLISHMENT_CREATE_PATH,
    ESTABLISHMENT_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'

const init = {
    _get_all_establishments: {
        data: [],
        status: 0,
        message: {},
    },
    _create_establishments: {
        data: {},
        status: 0,
        message: {},
    },
    _update_establishments: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_ESTABLISHMENTS_SUCCESS = "GET_ALL_ESTABLISHMENTS_SUCCESS";
export const CREATE_ESTABLISHMENTS_SUCCESS = "CREATE_ESTABLISHMENTS_SUCCESS";
export const UPDATE_ESTABLISHMENTS_SUCCESS = "UPDATE_ESTABLISHMENTS_SUCCESS";

export const establishment_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_ESTABLISHMENTS_SUCCESS:
            return {
                ...state,
                _get_all_establishments: action.payload,
            };
        case CREATE_ESTABLISHMENTS_SUCCESS:
            return {
                ...state,
                _create_establishments: action.payload,
            };
        case UPDATE_ESTABLISHMENTS_SUCCESS:
            return {
                ...state,
                _update_establishments: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const get_all_establishments = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${ESTABLISHMENT_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_ESTABLISHMENTS_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_ESTABLISHMENTS_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_ESTABLISHMENTS_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const create_establishments = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(`${URLAPI}${ESTABLISHMENT_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: CREATE_ESTABLISHMENTS_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_ESTABLISHMENTS_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: CREATE_ESTABLISHMENTS_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}


export const update_establishments = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${ESTABLISHMENT_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_ESTABLISHMENTS_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_ESTABLISHMENTS_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_ESTABLISHMENTS_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}


export const clear_establishment = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}
